import {isAssetCheckedOut} from '@netx/core-asset-next/utils';
import {
	allows,
	PermissionMatrixName,
} from '@netx/core-permissions/utils/allows';
import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {type IAsset} from '../schema';

export const canCreateShareLinkFromAsset = (asset?: IAsset) =>
	asset != null &&
	!isAssetCheckedOut(asset) &&
	currentUserMeetsUserLevel(UserLevel.CONSUMER) &&
	allows(asset.permissionMatrix, PermissionMatrixName.DOWNLOAD);

export default canCreateShareLinkFromAsset;
